<template>
  <div class="calculationAction">
    <div class="calculationAction-box">
      <div class="price-area">
        <span>Total</span>
        <em>¥{{ fullPrice }}</em>
        <button @click="changeDetailed(!controlDetailed)">
          <span :class="{ 'currentProhibit': !currentProhibit }">Detail</span>
          <img v-if="!currentProhibit" src="~@/assets/image/common/common_goTo2.png" alt="">
          <img v-else src="~@/assets/image/common/common_goTo.png" alt="">
        </button>
      </div>
      <button @click="nextStep" class="next-step">{{ nextStepName }}</button>
    </div>
    <div class="mask" @click.self="changeDetailed(false)" v-if="controlDetailed"></div>
    <div v-if="controlDetailed" class="detailed">
      <div class="detailed-title">Detail Information</div>
      <ul class="detailed-content">
        <li>
          <span>Ticket</span>
          <span>Unit Price</span>
          <span>Number</span>
        </li>
        <li v-for="item in controllerNumber" :key="item.productId" v-if="item.count">
          <span>{{ item.metaTicketInfo.englishName }}</span>
          <span>￥{{ item.salePrice }}</span>
          <span>x{{ item.count }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "calculationAction",
  props: {
    fullPrice: {
      type: Number,
    },
    controllerNumber: {
      type: Array
    },
    nextStepName: {
      type: String
    }
  },
  data() {
    return {
      controlDetailed: false,
      currentProhibit: null
    }
  },
  methods: {
    changeDetailed(isShow){
      // 判断要展开，并且有长度
      if(isShow === true && !this.controllerNumber.length)return;
      // 并且必须有数量
      if(!this.controllerNumber.some(v => v.count > 0))return;
      this.controlDetailed = isShow;
      this.$beyondHiding(isShow)
    },
    nextStep(){
      this.$emit('nextStep');
    }
  },
  watch: {
    controllerNumber: {
      handler(newValue){
        this.currentProhibit = newValue.some(item => item.count);
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style scoped lang='less'>
.calculationAction{
  height: 1.626667rem;
  background: #FFFFFF;
  border: 1px solid rgba(151, 151, 151, 0.16);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  .calculationAction-box{
    height: 1.626667rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    left: 0;
    width: 100%;
    z-index: 9999999999;
    top: 0;
    .price-area{
      display: flex;
      align-items: center;
      width: 5.92rem;
      padding-left: .4rem;
      height: 100%;
      background: #fff;
      span{
        font-size: .373333rem;
        color: #333333;
      }
      em{
        font-size: .5rem;
        font-weight: bold;
        color: #9D6C29;
        margin-left: .3rem;
      }
      button{
        display: flex;
        align-items: center;
        height: 0.586667rem;
        padding: 0 .4rem;
        white-space: nowrap;
        span{
          font-size: .373333rem;
          color: #9D6C29;
          line-height: 1;
          margin-right: .066667rem;
        };
        .currentProhibit{
          color: #999 !important;
        }
        img{
          height: .32rem;
        }
      }
    };
    .next-step{
      flex: 1;
      height: 100%;
      background: #9D6C29;
      font-size: .4rem;
      font-weight: bold;
      line-height: .56rem;
      color: #FFFFFF;
    }
  }
  .detailed{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    transform: translateY(-100%);
    background: #FFFFFF;
    z-index: 9999999999;
    box-shadow: 0 .053333rem .106667rem 0 rgba(192,5,0,0.08);
    border-radius: .546667rem .546667rem 0 0;
    .detailed-title{
      font-size: .48rem;
      font-weight: bold;
      color: #000000;
      line-height: .666667rem;
      padding: .346667rem 0 .266667rem;
      text-align: center;
    }
    .detailed-content{
      padding: .666667rem .4rem ;
      li{
        font-size: .4rem;
        color: #000000;
        line-height: .56rem;
        display: flex;
        justify-content: space-between;
        margin-bottom: .466667rem;
        &:first-child{
          font-weight: bold;
        }
        &:last-child{
          margin-bottom: 0;
        }
        span{
          width: 33.33%;
          &:nth-child(2){
            text-align: center;
          }
          &:last-child{
            text-align: right;
          }
        }
      }
    }
  }
};

.mask{
  background: rgba(0, 0, 0, .3);
  position: fixed;
  z-index: 999;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
}
</style>
